import React from 'react';
import styles from './styles.module.scss';
import cx from 'classnames';
import { Image, Clearfix } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export class ToolBar extends React.Component {
  constructor(props){
    super(props);
  }

  render() {
    return (
      <div className={ cx(styles.toolBar, this.props.className) } style={ this.props.style }>
        <div className={styles.inner}>
          { this.props.children }
          {/* <Clearfix /> */}
        </div>
      </div>
    );
  }
}

export class ToolBarGroup extends React.Component {
  constructor(props){
    super(props);
  }

  render() {
    return (
      <ul className={ cx(styles.group, this.props.direction, this.props.group, this.props.className) }>
        { this._renderChildrenItems() }
      </ul>
    );
  }

  _renderChildrenItems(){
    let itemNodes = React.Children.map(this.props.children, (child, index) => {
      if(child){
        let itemElement = React.cloneElement(child);

        return (
          <li className={ cx(styles.item, this.props.item) }>
            { itemElement }
          </li>
        );
      }
    });

    return itemNodes;
  }
}

ToolBarGroup.defaultProps = {direction: 'left'}

export class ToolBarTabItem  extends React.Component {
  constructor(props){
    super(props);

    this._handleClick = this._handleClick.bind(this);
  }

  _handleClick() {
    if(this.props.onClick) {
      this.props.onClick();
    }
  }

  render() {
    return(
      <div className={cx(styles.tabItem, this.props.className)}>
        <Link to={this.props.to} onClick={this._handleClick}>
          <div className={styles.tabIcon}>
            <Image src={this.props.icon} />
          </div>

          {this.props.children &&
            <div className={styles.label}>
              { this.props.children }
            </div>
          }
        </Link>
      </div>
    );
  }
}

export class ToolBarTitle extends React.Component {
  constructor(props){
    super(props);
  }

  render() {
    return(
      <div className={cx(styles.toolBarTitle, this.props.className)}>
        <div className={styles.inner}>
          <div className={styles.heading}>{this.props.title}</div>
          <div className={styles.prompt}>{this.props.prompt}</div>
        </div>
      </div>
    );
  }
}
